var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpdated(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, ".st0{fill:#FFFFFF;}.st1{fill:#4277AD;}.st2{fill:#69B631;}.st3{fill:#FFCC02;}.st4{fill:#9E7215;}.st5{fill:#62A9FF;}.st6{fill:#2C3E50;}.st7{fill:#B3B3B3;}.st8{fill:#B23A3A;}.st9{fill:#346BA9;}.st10{fill:#171717;}.st11{opacity:0.5;fill:#62A9FF;}.st12{fill:#676767;}.st13{fill:#E56615;}")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M3,10.5v2h2c0.2,0,0.4-0.1,0.5-0.2l4.4-4.4L7.6,5.6L3.2,10C3.1,10.1,3,10.3,3,10.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M8.4,4.8l2.3,2.3L11.8,6c0.2-0.2,0.2-0.5,0-0.7l-1.6-1.6c-0.2-0.2-0.5-0.2-0.7,0L8.4,4.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 11.5,
    className: "st5",
    width: 5,
    height: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdated);
export default __webpack_public_path__ + "static/media/updated.1fc378742772f4c3102a7af9a3d3ec8d.svg";
export { ForwardRef as ReactComponent };